import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CustomCommonModule } from './common/custom-common.module';
import { DataService } from './common/services/data.service';
import { UserCacheService } from './common/services/user-cache.service';
import { PageNotFoundComponent } from './pages/public/page-not-found/page-not-found.component';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { AppConfigService } from './main/app-config.service';

@NgModule({ declarations: [
        AppComponent,
        PageNotFoundComponent
    ],
    // providers: [{ provide: APP_BASE_HREF, useValue: '/sae/' }],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], 
    imports: [BrowserModule,
        AppRoutingModule,
        CommonModule,
        CustomCommonModule,
        ReactiveFormsModule,
        NgIdleKeepaliveModule.forRoot()], 
    providers: [
        UserCacheService,
        DataService,
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
        {
            provide: APP_INITIALIZER,
            useFactory: initConfig,
            deps: [AppConfigService],
            multi: true
        }
    ] 
})
export class AppModule { }
export function initConfig(appConfig: AppConfigService) {
    return () => appConfig.loadConfig();
}